// extracted by mini-css-extract-plugin
module.exports = {"page":"Pagination_page__tIGCK","icon":"Pagination_icon__4aISO","next":"Pagination_next__VXZ82","prev":"Pagination_prev__XqGDV"};